module.exports = __webpack_public_path__ + "assets/retina_IncenterDetailed.be675b20a310f4ab823bae02ecf73944.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_IncenterDetailed.png
// module id = 678
// module chunks = 0